import { render, staticRenderFns } from "./PermissionPopup.vue?vue&type=template&id=8ef27930&scoped=true&"
import script from "./PermissionPopup.vue?vue&type=script&lang=js&"
export * from "./PermissionPopup.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPopup.vue?vue&type=style&index=0&id=8ef27930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef27930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef27930')) {
      api.createRecord('8ef27930', component.options)
    } else {
      api.reload('8ef27930', component.options)
    }
    module.hot.accept("./PermissionPopup.vue?vue&type=template&id=8ef27930&scoped=true&", function () {
      api.rerender('8ef27930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/roles/PermissionPopup.vue"
export default component.exports